import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchOrganigrama = async () => {
  const res = await axios.get(`${API_URL}/api/organigrama`, {
    headers: authHeader(),
  });
  return {
    locales: res.data?.locales ?? null,
    canEdit: !!res.data?.canEdit,
    canPrint: res.data?.canPrint !== false,
  };
};

export const saveOrganigramaRoles = async (locale, roles) => {
  const res = await axios.put(
    `${API_URL}/api/organigrama`,
    { locale, roles },
    { headers: authHeader() },
  );
  return res.data;
};
